//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'

import { DataProvider } from '../../helpers/data-provider'
import { TypeHelper } from '../../helpers/type-helper'

import { OpDescr } from './op-descr'

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Utils } from '../util/utils'

export class OpDataTypeFormat implements IReferenceType, IOpChangeState, IJsonSerializable {

    // Properties

    public idDataTypeFormat: any
    public idDescr: number

    public isRequired: boolean
    public datetimeFormat: string
    public numberMaxPrecision: number
    public numberMaxScale: number
    public numberMaxValue: number
    public numberMinPrecision: number
    public numberMinScale: number
    public numberMinValue: number
    public regularExpression: string
    public textMaxLength: number
    public textMinLength: number

    // Properties End

    // NavigationProperties

    public descr: OpDescr

    // NavigationProperties End


    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDataTypeFormat
    }
    public getReferenceKey(): number {
        return this.idDataTypeFormat
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || Utils.isJSONCompressed(opObj)) {
                this.idDataTypeFormat = opObj.I
                this.idDescr = opObj.ID

                this.isRequired = opObj.R
                this.datetimeFormat = opObj.DF

                this.numberMaxPrecision = opObj.NMAP
                this.numberMaxScale = opObj.NMAS
                this.numberMaxValue = opObj.NMAV
                this.numberMinPrecision = opObj.NMIP
                this.numberMinScale = opObj.NMIS
                this.numberMinValue = opObj.NMIV
                this.regularExpression = opObj.RE
                this.textMaxLength = opObj.TMAL
                this.textMinLength = opObj.TMIL

                this.descr = opObj.D ? new OpDescr(opObj.D) : null

                this.opState = opObj.O
            }
            else {
                this.idDataTypeFormat = opObj.ID_DATA_TYPE_FORMAT
                this.idDescr = opObj.ID_DESCR

                this.isRequired = opObj.IS_REQUIRED
                this.datetimeFormat = opObj.DATETIME_FORMAT
                this.numberMaxPrecision = opObj.NUMBER_MAX_PRECISION
                this.numberMaxScale = opObj.NUMBER_MAX_SCALE
                this.numberMaxValue = opObj.NUMBER_MAX_VALUE
                this.numberMinPrecision = opObj.NUMBER_MIN_PRECISION
                this.numberMinScale = opObj.NUMBER_MIN_SCALE
                this.numberMinValue = opObj.NUMBER_MIN_VALUE
                this.regularExpression = opObj.REGULAR_EXPRESSION
                this.textMaxLength = opObj.TEXT_MAX_LENGTH
                this.textMinLength = opObj.TEXT_MIN_LENGTH

                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null

                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const compressedObj: any = {
                I: this.idDataTypeFormat,
                ID: this.idDescr,

                R: this.isRequired,
                DF: this.datetimeFormat,

                NMAP: this.numberMaxPrecision,
                NMAS: this.numberMaxScale,
                NMAV: this.numberMaxValue,
                NMIP: this.numberMinPrecision,
                NMIS: this.numberMinScale,
                NMIV: this.numberMinValue,
                RE: this.regularExpression,
                TMAL: this.textMaxLength,
                TMIL: this.textMinLength,

                D: this.descr ? this.descr.toJSON(compressed) : null,

                O: this.opState,
            }

            Utils.setJSONCompressedFlag(compressedObj)
            TypeHelper.deleteNulls(compressedObj)

            return compressedObj
        }
        else {
            return {
                ID_DATA_TYPE_FORMAT: this.idDataTypeFormat,
                ID_DESCR: this.idDescr,

                IS_REQUIRED: this.isRequired,
                DATETIME_FORMAT: this.datetimeFormat,
                NUMBER_MAX_PRECISION: this.numberMaxPrecision,
                NUMBER_MAX_SCALE: this.numberMaxScale,
                NUMBER_MAX_VALUE: this.numberMaxValue,
                NUMBER_MIN_PRECISION: this.numberMinPrecision,
                NUMBER_MIN_SCALE: this.numberMinScale,
                NUMBER_MIN_VALUE: this.numberMinValue,
                REGULAR_EXPRESSION: this.regularExpression,
                TEXT_MAX_LENGTH: this.textMaxLength,
                TEXT_MIN_LENGTH: this.textMinLength,

                _Descr: this.descr != null ? this.descr.toJSON() : null,

                OpState: this.opState
            }
        }
    }

    public toString() {
        if (this.descr) {
            return this.descr.description
        } else {
            // TODO: info od Łukasza Pieła że na póżniej
            /*
                StringBuilder sb = new StringBuilder();
                if (TextMinLength.HasValue || TextMaxLength.HasValue)
                    sb.AppendFormat("{0} [{1} - {2}] ",
                        ResourcesText.Text,
                        TextMinLength.HasValue ? TextMinLength.Value.ToString() : "?",
                        TextMaxLength.HasValue ? TextMaxLength.Value.ToString() : "?");
                if (NumberMinPrecision.HasValue || NumberMinScale.HasValue || NumberMinValue.HasValue
                    || NumberMaxPrecision.HasValue || NumberMaxScale.HasValue || NumberMaxValue.HasValue)
                    sb.AppendFormat("{0} [{1} - {2}] {3} [{4} - {5}] {6} [{7} - {8}] ",
                        ResourcesText.Number,
                        NumberMinValue.HasValue ? NumberMinValue.Value.ToString() : "?",
                        NumberMaxValue.HasValue ? NumberMaxValue.Value.ToString() : "?",
                        ResourcesText.Precision,
                        NumberMinPrecision.HasValue ? NumberMinPrecision.Value.ToString() : "?",
                        NumberMaxPrecision.HasValue ? NumberMaxPrecision.Value.ToString() : "?",
                        ResourcesText.Scale,
                        NumberMinScale.HasValue ? NumberMinScale.Value.ToString() : "?",
                        NumberMaxScale.HasValue ? NumberMaxScale.Value.ToString() : "?");
                if (!String.IsNullOrWhiteSpace(DatetimeFormat))
                    sb.AppendFormat("{0} [{1}] ", ResourcesText.DatetimeFormat, DatetimeFormat);
                if (!String.IsNullOrWhiteSpace(RegularExpression))
                    sb.AppendFormat("RegEx [{0}] ", RegularExpression);
                if (IsRequired.HasValue)
                    sb.AppendFormat("{0} [{1}] ", ResourcesText.Required, IsRequired.Value);
                if (sb.Length == 0) return ResourcesText.DescriptionMissing;
                else return sb.ToString();
            */
            return this.idDataTypeFormat + ''
        }
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDataTypeFormat[]): JQueryPromise<OpDataTypeFormat[]> {
        var defered = $.Deferred<OpDataTypeFormat[]>()

        defered.resolve(list)

        return defered.promise()
    }

    public static restore(restoredOpObj: OpDataTypeFormat) {
        if (restoredOpObj) {
            var opObj = new OpDataTypeFormat()
            opObj.idDataTypeFormat = restoredOpObj.idDataTypeFormat
            opObj.isRequired = restoredOpObj.isRequired
            opObj.numberMaxPrecision = restoredOpObj.numberMaxPrecision
            opObj.numberMaxScale = restoredOpObj.numberMaxScale
            opObj.numberMaxValue = restoredOpObj.numberMaxValue
            opObj.numberMinPrecision = restoredOpObj.numberMinPrecision
            opObj.numberMinScale = restoredOpObj.numberMinScale
            opObj.numberMinValue = restoredOpObj.numberMinValue
            opObj.regularExpression = restoredOpObj.regularExpression
            opObj.textMaxLength = restoredOpObj.textMaxLength
            opObj.textMinLength = restoredOpObj.textMinLength
            opObj.idDescr = restoredOpObj.idDescr
            opObj.descr = OpDescr.restore(restoredOpObj.descr)
            opObj.opState = restoredOpObj.opState
            return opObj
        }
        return null
    }
}